import React from 'react';
import { Col, Row } from 'reactstrap';
import catImg from '../../../../assets/images/dummyImages/cat-1.jpeg';

const SpecificCategories = () => {
    const categories = [
        { name: "Electronics", image: catImg },
        { name: "Fashion", image: catImg },
        { name: "Home & Kitchen", image: catImg },
        { name: "Beauty & Personal Care", image: catImg },
        { name: "Sports & Outdoors", image: catImg },
        { name: "Books & Media", image: catImg },
        { name: "Toys & Games", image: catImg },
    ];

    return (
        <div>
            <div className='pb-2'>Coupon is Applied to following Categories:</div>
            <Row className="g-4">
                {categories.map((category, index) => (
                    <Col key={index} xl='6' lg='6' md='6' sm='6' xs='12'>
                        <div
                            style={{
                                height: '48px',
                                background: `
                                    linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
                                    url(${category.image})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white', // Adjust text color as needed
                            }}
                        >
                            {category.name}
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default SpecificCategories;
